<template>
  <div class="footer-contacts">
    <div class="contact">
      <div class="flex justify-center md:justify-start">
        <div class="flex flex-col md:flex-row items-center md:items-start gap-2">
          <span class="highlight-yellow">
            1(714) 875 – 8364
          </span>
          <span class="highlight-grey">
            OMARGSABHA@GMAIL.COM
          </span>
        </div>
      </div>
    </div>
    <div class="social">
      <div class="flex justify-center md:justify-start">
        <div class="flex flex-wrap items-center gap-4 mt-4 text-lg">
          <a href="https://www.facebook.com/profile.php?id=100028848440825" target="_blank" rel="nofollow noopener noreferrer" class="hover:underline">Facebook</a>
          <a href="https://www.instagram.com/empire_training_grounds" target="_blank" rel="nofollow noopener noreferrer" class="hover:underline">IG - Buena Park</a>
          <a href="https://www.instagram.com/empire_irvine" target="_blank" rel="nofollow noopener noreferrer" class="hover:underline">IG - Irvine</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FooterContacts'
  }
</script>
  
<style scoped>
  .contact span {
    padding: 4px 12px;
  }
  
  .highlight-yellow {
    background-color: var(--empire-yellow);
    color: var(--empire-black-text);
  }
  
  .highlight-grey {
    background-color: rgba(255, 255, 255, 0.2);
    color: var(--empire-white-text);
  }

  .social {
    text-transform: uppercase;
    font-style: italic;
  }

  .social a {
    color: var(--empire-white-text);
    text-decoration: underline;
  }
  .social a:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
</style>